<script setup lang="ts">
  import type { DownloadableFile } from '@/types/File'
  import DownloadIcon from '@/components/icons/DownloadIcon.vue'
  import FileDownload from '@/components/common/FileDownload.vue'
  import { computed } from 'vue'
  import { useFileDownload } from '@/composables/useFileDownload'

  const file = withDefaults(defineProps<DownloadableFile>(), {
    bytes: 0,
    fieldIdentifier: 'file',
    isCollection: false,
  })

  const { readableMimeType } = useFileDownload()
  const mimeType = computed(() => readableMimeType(file.mimeType))
</script>

<template>
  <FileDownload
    :class="{ 'file-block': !isCollection }"
    :file="file"
  >
    <div class="link">
      <div
        class="left"
        v-text="file.name"
      />
      <div class="right">
        <span
          v-if="mimeType"
          v-text="mimeType"
        />
        <DownloadIcon />
      </div>
    </div>
  </FileDownload>
</template>

<style lang="scss">
  .collection {
    margin: 0 0 40px;
  }
</style>

<style scoped lang="scss">
  .file-block {
    display: block;
    margin: 0 0 40px;
  }

  a {
    text-decoration: none;
    color: var(--app-theme-color)
  }

  .link {
    border: 2px solid var(--color-gray-20);
    width: auto;
    display: flex;
    background: var(--color-white);
    padding: 16px;
    justify-content: space-between;
    margin: 5px 0;
    gap: 30px;

    &:hover {
      background: var(--ks-borderhoverfill);
      transition: .3s;
    }

    .left {
      align-items: center;
      display: flex;
      padding-right: 50px;
      font-weight: 700;
    }

    .right {
      display: flex;
      gap: 19px;
      align-items: center;

      span {
        color: var(--color-gray-40);
        padding-top: 3px;
      }

      svg {
        fill: var(--app-theme-color);
      }
    }
  }
</style>
